"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WeekdayMobile_1 = __importDefault(require("./WeekdayMobile"));
const HeaderMobile = ({ currentMoment }) => {
    if (currentMoment.get('month') === 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "smls-calendar-header-mobile" },
                react_1.default.createElement("strong", { style: { textTransform: 'capitalize', marginRight: '6px' } }, currentMoment.format('MMMM')),
                react_1.default.createElement("span", { style: { fontWeight: 400 } }, currentMoment.format('YYYY'))),
            react_1.default.createElement(WeekdayMobile_1.default, null)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("strong", { className: "smls-calendar-header-mobile", style: { textTransform: 'capitalize' }, "data-testid": "header-mobile-month" }, currentMoment.format('MMMM')),
        react_1.default.createElement(WeekdayMobile_1.default, null)));
};
exports.default = HeaderMobile;
//# sourceMappingURL=HeaderMobile.js.map